// Auto-generated by scripts/generate-whitelabel.js — DO NOT EDIT
// Generated at: 2026-07-28T07:59:13.537Z

import { WHITELABEL_COVER_PAGE_CONSTANTS } from '@modules/whitelabel-cover-page/whitelabel-cover-page.constants';

export const WHITELABEL_COVER_PAGE_RESPONSE: any = null;

export const IS_WHITELABEL_COVER_PAGE_PUBLISHED =
  WHITELABEL_COVER_PAGE_RESPONSE?.data?.status ===
  WHITELABEL_COVER_PAGE_CONSTANTS.STATUS_PUBLISHED;
